module.exports = __webpack_public_path__ + "img/step-01-download.6987d746.svg";